export default {
    methods: {
        getCTATitlePrimary() {
            if(this.defaultActionType === 'CONTACT_SUPPORT') {
                if(this.isExternalHelpdesk) {
                    return this.$t('customerJourneyPreChatForm.contactSupport')
                } else {
                    return this.$t('homeScreen.sendUsMessage')
                }
            } else if(this.defaultActionType === 'ATTEMPT_TO_CLOSE') {
                return this.$t('customerJourneyPreChatForm.noThanks')
            } else if(this.defaultActionType === 'ASK_FOR_RATING') {
                return this.$t('customerJourneyPreChatForm.yes')
            }
        },

        getCTATitleSecondary() {
            if(this.defaultActionType === 'CONTACT_SUPPORT') {
                return this.$t('customerJourneyPreChatForm.noThanks')
            } else if(this.defaultActionType === 'ATTEMPT_TO_CLOSE') { 
                return this.$t('homeScreen.sendUsMessage')
            } else if(this.defaultActionType === 'ASK_FOR_RATING') {
                return this.$t('customerJourneyPreChatForm.no')
            } else {
                return ''
            }
        },
      
        getSecondaryCTAAction() {
            if(this.defaultActionType === 'CONTACT_SUPPORT') {
                return 'ATTEMPT_TO_CLOSE';
            } else if(this.defaultActionType === 'ATTEMPT_TO_CLOSE') {
                return 'CONTACT_SUPPORT'
            }
            else if(this.defaultActionType === 'ASK_FOR_RATING') {
                return 'ASK_FOR_RATING_NO'
            }
        },
    },
    computed: {
        defaultActionData() {
            return {
                    secondaryCTAConfig: {
                        title: this.getCTATitleSecondary(),
                        action: this.getSecondaryCTAAction(),
                    },
                    primaryCTAConfig: {
                        title: this.getCTATitlePrimary(),
                        action: this.defaultActionType,
                    },
            }
        },
    }
}